import { ApolloQueryResult, useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import { useCurrentBusinessId } from './useCurrentBusinessId';

interface ChannelListHook {
  channels: API.ChannelListItemFragment[];
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<API.ChannelListQuery>>;
}

export function useChannelList(): ChannelListHook {
  const businessId = useCurrentBusinessId();
  const { data, loading, refetch } = useQuery<API.ChannelListQuery, API.ChannelListQueryVariables>(
    Queries.channel.list,
    {
      variables: { businessId: businessId ?? -1 },
      skip: isNil(businessId),
    },
  );

  return useMemo(
    () => ({
      channels: data?.me?.business?.channels?.filter(notNil) ?? [],
      loading,
      refetch,
    }),
    [data, loading, refetch],
  );
}
